import { Pagination, useTable } from '@lhb/hook';
import { GetList } from '@lhb/regexp';
import { useEffect, useState } from 'react';

interface TableProps {
  loading: boolean;
  pagination: Pagination;
  dataSource: any[];
}

interface SearchFormProps<T> {
  onSearch: (values: T) => void;
  onReset: () => void;
  onRefresh: () => void
  searchParams: any;
  onChange?: (values: T) => void;
}

type Result<T> = [TableProps, SearchFormProps<T>, Record<string, any>];

function useSearchForm<T> (getList: GetList, transformSearchParams?: (values: T) => any): Result<T> {
  const [searchParams, setSearchParams] = useState<T |((values: T) => T)>({} as any);
  const [values, setValues] = useState<any>({});
  const [{ loading, pagination }, result]:any = useTable(getList, values);

  const { objectList = [], records = [], meta, total = 0 } = result || {};
  if (total) {
    pagination.total = total;
    pagination.showTotal = () => {
      return `共有${total}条记录，当前第${pagination.current}页`;
    };
  }


  const onSearch = (values: T) => {
    setSearchParams(values as any);
    pagination.onChange(1);
  };

  const onReset = () => {
    setSearchParams({} as any);
    pagination.onChange(1);
  };

  // 刷新不会调用transformSearchParams，如果改变入参不能调用此方法
  const onRefresh = () => {
    setValues({ ...values });
  };

  const onChange = (values: T) => {
    setSearchParams(values);
  };

  useEffect(() => {
    setValues(transformSearchParams ? transformSearchParams(searchParams as any) : searchParams);
  }, [searchParams]);

  const tableProps = {
    dataSource: objectList.length ? objectList : records, // 兼容pms和中台返回格式
    loading,
    pagination
  };

  const searchFormProps = {
    onSearch,
    onReset,
    onRefresh,
    searchParams,
    onChange
  };

  return [tableProps, searchFormProps, meta];
}

export default useSearchForm;

